export default (httpClient) => ({

  getBalance(personId) {
    return httpClient.get(`/people/${personId}/store/credit`);
  },

  getHistory(personId, params) {
    return httpClient.get(`/people/${personId}/store/transactions`, params);
  },

  async getConfigV3(config) {
    return httpClient.hosts.v3.get(`rest/1/config?name=${config}`);
  },

})